module.exports = __webpack_public_path__ + "static/media/deposits.1721d5ff.svg";